import React , { Suspense, lazy , useState , createContext , useEffect } from "react";
import logo from './logo.png';
import tableuserDefaultImg from './assets/avatar.png';
import 'react-tooltip/dist/react-tooltip.css';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import { Tooltip } from 'react-tooltip'
import Login from './admin/Login';
import Layout from './components/admin/layout/Layout';
import Dashboard from './admin/Dashboard';
import Users from './admin/Users';
import Useredit from './admin/Useredit';
import Useradd from './admin/Useradd';
import Userview from './admin/Userview';
import Product from './admin/Product';
import Productedit from './admin/Productedit';
import Productpricehistory from './admin/Productpricehistory';
import Productadd from './admin/Productadd';
import Commodityorders from './admin/Commodityorders';
import Commodityordersview from './admin/Commodityordersview';
import Transactions from './admin/Transactions';
import Commission from './admin/Commission';
import Slider from './admin/Slider';
import Pages from './admin/Pages';
import Settings from './admin/Settings';
import Profile from './admin/Profile';
import Notfound from './admin/Notfound';
import ReactDOM from "react-dom/client";
import { unstable_HistoryRouter , BrowserRouter as Router, Routes  ,  Redirect  , Route, Link ,  Navigate , useNavigate,   useParams } from "react-router-dom";
import Swal from 'sweetalert2';
import Webroute from './Webroute';

import 
{ 
  changeDateFotmate,
  currencySymbol
} from './functions/Function';


const WebAssetsContext = createContext();


function App() {

  let getuserloggedIn = JSON.parse(localStorage.getItem("admin"));
  const [userloggedIn, setUserloggedIn] = useState(getuserloggedIn); 
  const logout = (e) => {
    e.preventDefault();
    localStorage.removeItem("admin");
    setUserloggedIn(null);
  };
  
  const LoggedInAdmin = () =>
  {
    let getuserloggedIn = JSON.parse(localStorage.getItem("admin"));
    if(getuserloggedIn)
    {
      setUserloggedIn(getuserloggedIn);
    }else
    {
      setUserloggedIn(null);
    }
  }
  const [AdminAssets, setAdminAssets] = useState(
      { 
        apiURL: 'https://projects.softechplanet.com/ivoire/api/' ,
        logo: logo ,
        tableuserDefaultImg:tableuserDefaultImg,
        LoggedInAdmin:LoggedInAdmin,
        logout:logout,
      });

      const Protected = ({ children }) => {
          if (userloggedIn == null) {
              return <Navigate to="/admin/login" replace />;
          }
          return children;
        };

  useEffect(() => {
    LoggedInAdmin();
    
    let test =  localStorage.getItem("test");
    let test1 =  localStorage.getItem("admin");
    
    
  },[])
  

  
  return (
    <>
     
      <WebAssetsContext.Provider value={AdminAssets}>

          
            <Router>
                <Webroute/>
              <Routes>
                
                <Route path="/admin" element={ <Protected><Layout /></Protected> }>
                 
                  <Route index  element={
                  <Protected>
                    <Navigate replace to={"/admin/dashboard"} />
                  </Protected>
                }  
                />
                <Route
                        
                      path="/admin/dashboard"
                      element={
                        <Protected>
                          <Dashboard 
                          changeDateFotmate={changeDateFotmate} 
                          currencySymbol={currencySymbol}  /> 
                        </Protected>
                      }
                  />

                <Route
                      exact
                      path="/admin/users"
                      element={
                        <Protected>
                          <Users 
                          changeDateFotmate={changeDateFotmate} 
                          currencySymbol={currencySymbol} 
                          /> 
                        </Protected>
                      }
                  />

                  <Route
                      exact
                      path="/admin/users/add"
                      element={
                        <Protected>
                            <Useradd /> 
                        </Protected>
                        }
                  />

                  <Route
                      exact
                      path="/admin/users/edit/:id"
                      element={
                        <Protected>
                          <Useredit />
                      </Protected>
                      }
                  />

                  <Route
                      exact
                      path="/admin/users/view/:id"
                      element={
                        <Protected>
                          <Userview />
                      </Protected>
                      }
                  />

                  <Route
                      exact
                      path="/admin/products"
                      element={
                        <Protected>
                          <Product 
                            changeDateFotmate={changeDateFotmate} 
                            currencySymbol={currencySymbol} 
                          /> 
                      </Protected>
                    }
                  />

                  <Route
                      exact
                      path="/admin/products/add"
                      element={
                        <Protected>
                          <Productadd /> 
                      </Protected>
                      }
                  />

                  <Route
                      exact
                      path="/admin/products/edit/:id"
                      element={
                        <Protected>
                          <Productedit /> 
                        </Protected>
                      }
                  />

                  <Route
                      exact
                      path="/admin/products/price-history/:id"
                      element={
                        <Protected>
                            <Productpricehistory
                              changeDateFotmate={changeDateFotmate} 
                              currencySymbol={currencySymbol} 
                            />
                      </Protected>
                    }
                  />

                  <Route
                      exact
                      path="/admin/commodity-orders"
                      element={
                        <Protected>
                          <Commodityorders
                            changeDateFotmate={changeDateFotmate} 
                            currencySymbol={currencySymbol} />
                      </Protected>
                      }
                  />

                  <Route
                      exact
                      path="/admin/commodity-orders/view/:id"
                      element={
                        <Protected>
                          <Commodityordersview 
                              changeDateFotmate={changeDateFotmate} 
                              currencySymbol={currencySymbol}
                            /> 
                      </Protected>
                    }
                  />

                  <Route
                      exact
                      path="/admin/transactions"
                      element={
                        <Protected>
                          <Transactions 
                              changeDateFotmate={changeDateFotmate} 
                              currencySymbol={currencySymbol} 
                            />
                        </Protected>
                    }
                  />

                  <Route
                      exact
                      path="/admin/commission"
                      element={
                        <Protected>
                          <Commission 
                              changeDateFotmate={changeDateFotmate} 
                              currencySymbol={currencySymbol} 
                            />
                        </Protected>
                    }
                  />



                  <Route
                      exact
                      path="/admin/slider"
                      element={
                      <Protected> 
                        <Slider /> 
                      </Protected>
                      }
                  />

                  <Route
                      exact
                      path="/admin/settings"
                      element={
                        <Protected> 
                            <Settings />
                        </Protected>
                        }
                  />

                  <Route
                      exact
                      path="/admin/pages"
                      element={
                        <Protected>
                          <Pages /> 
                        </Protected>
                      }
                  />

                  <Route
                      exact
                      path="/admin/profile"
                      element={
                        <Protected>
                            <Profile />
                        </Protected>
                      }
                  />

                  <Route
                      path="*"
                      element={<Notfound />}
                  />


                </Route>
                <Route
                    exact
                    path="/admin/login"
                    element={userloggedIn == null ? <Login /> : 
                    <Navigate replace to={"/admin/dashboard"} />
                  
                  
                  }
                />

                
              </Routes>

            

            </Router>
          </WebAssetsContext.Provider>
       
   
    </>
  );
}


export default App;
export { WebAssetsContext};



